import axios from "axios";
import { Constants } from '../../utils/Constants';
import { adaptPayload } from "../../utils/formUtils";

export function getPerfil() {
	return axios.get(`${Constants.baseUrlEmpresa}`);
}

export function editPerfil(data) {
	return axios.post(`${Constants.baseUrlEmpresa}/edit`, adaptPayload(data));
}
